import { SvgIcon } from "@mui/material";
import { IIconProps, IStyleProps } from "@/models";
import { memo } from "react";
import clsx from "clsx";

const DotSquare = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 32 32"
      sx={{
        fontSize: "inherit",
        border: `1.3px solid currentColor`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "1.5px",
        ...sx,
      }}
      className={clsx("icon-DotSquare", className)}
      {...otherProps}
    >
      <circle cx="16" cy="16" r="4.5" fill="currentColor" />
    </SvgIcon>
  );
};
export default memo(DotSquare);
